import api from './api';
import { ModeleBoitier } from '../types';

export const modeleBoitierService = {
  getAll: async (): Promise<ModeleBoitier[]> => {
    const { data } = await api.get('/api/modeles-boitier');
    return data;
  },
  create: async (nom: string): Promise<ModeleBoitier> => {
    const { data } = await api.post('/api/modeles-boitier', { nom });
    return data;
  },
  update: async (id: number, nom: string): Promise<ModeleBoitier> => {
    const { data } = await api.put(`/api/modeles-boitier/${id}`, { nom });
    return data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/modeles-boitier/${id}`);
  },
};
